export const AMENDMENT_ATTACHMENT_SCOPES = {
    ATTACHED: 'attached',
    STANDALONE: 'standalone',
};

export const AMENDMENT_DURATION_UNITS = {
    MINUTES: 'minutes',
    HOURS: 'hours',
};